import { buildOverlapRows } from "@/lib/programmeOverlap";

const MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
const WEEKDAYS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];

function longDate(value) {
  const d = new Date(value);
  if (isNaN(d)) return value || "";
  return `${WEEKDAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

const CAT_TINTS = ["#6366f1", "#0ea5e9", "#10b981", "#f59e0b", "#ec4899", "#8b5cf6", "#14b8a6", "#ef4444"];
function esc(s) { return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }

export function printProgramme(event, days, activitiesByDay, company = {}) {
  const w = window.open("", "_blank");
  if (!w) return;
  const color = event.color || "#6366f1";
  const sortedDays = [...days].sort((a, b) => a.dayNumber - b.dayNumber);

  const catColors = {};
  let ci = 0;
  const allActs = sortedDays.flatMap((d) => activitiesByDay(d.id));
  allActs.forEach((a) => { const c = a.category || "Général"; if (!catColors[c]) catColors[c] = CAT_TINTS[ci++ % CAT_TINTS.length]; });
  const totalActs = allActs.length;

  const dateRange = event.endDate && event.endDate !== event.startDate
    ? `${longDate(event.startDate)} → ${longDate(event.endDate)}`
    : longDate(event.startDate);

  const daysHtml = sortedDays.map((d, di) => {
    const acts = [...activitiesByDay(d.id)].sort((a, b) => (a.startTime || "").localeCompare(b.startTime || ""));
    const groups = buildOverlapRows(acts);
    const items = groups.map((group) => {
      const firstCategory = group.items[0]?.activity?.category || "Général";
      const groupTint = catColors[firstCategory] || color;
      const cards = group.items.map(({ activity: a, isContinuation }) => {
        const cat = a.category || "Général";
        const tint = catColors[cat] || color;
        const meta = [
        a.location ? `<span class="chip"><svg viewBox="0 0 24 24"><path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>${esc(a.location)}</span>` : "",
        a.speaker ? `<span class="chip"><svg viewBox="0 0 24 24"><path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.9V21h2v-3.1A7 7 0 0 0 19 11h-2z"/></svg>${esc(a.speaker)}</span>` : "",
        a.language ? `<span class="chip"><svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm6.9 6h-2.6a15.6 15.6 0 0 0-1.3-3.3A8 8 0 0 1 18.9 8zM12 4c.8 1.1 1.4 2.5 1.8 4h-3.6C10.6 6.5 11.2 5.1 12 4zM4.3 14a8 8 0 0 1 0-4h3a17 17 0 0 0 0 4zm.8 2h2.6c.3 1.2.8 2.3 1.3 3.3A8 8 0 0 1 5.1 16zM7.7 8H5.1a8 8 0 0 1 3.9-3.3C8.5 5.7 8 6.8 7.7 8zM12 20c-.8-1.1-1.4-2.5-1.8-4h3.6c-.4 1.5-1 2.9-1.8 4zm2.2-6H9.8a15 15 0 0 1 0-4h4.4a15 15 0 0 1 0 4zm.7 5.3c.5-1 1-2.1 1.3-3.3h2.6a8 8 0 0 1-3.9 3.3zM17 14a17 17 0 0 0 0-4h3a8 8 0 0 1 0 4z"/></svg>${esc(a.language)}</span>` : "",
        a.maxSeats ? `<span class="chip"><svg viewBox="0 0 24 24"><path d="M16 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm-8 0a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-2.7 0-8 1.3-8 4v3h9v-3c0-1 .4-1.9 1-2.6A13 13 0 0 0 8 13zm8 0c-.5 0-1 0-1.6.1A5 5 0 0 1 16 17v3h8v-3c0-2.7-5.3-4-8-4z"/></svg>${esc(a.maxSeats)} places</span>` : "",
        ].filter(Boolean).join("");
        return `<div class="card" style="--tint:${tint}">
          ${a.location ? `<p class="room">${esc(a.location)}</p>` : ""}
          <div class="card-head">
            <h3>${esc(a.title || "Activité")}${isContinuation ? " (suite)" : ""}</h3>
            <span class="cat" style="background:${tint}1a;color:${tint}">${esc(cat)}</span>
          </div>
          ${a.description ? `<p class="descr">${esc(a.description)}</p>` : ""}
          ${a.endTime ? `<p class="ends-at">Fin : ${esc(a.endTime)}</p>` : ""}
          ${meta ? `<div class="metas">${meta}</div>` : ""}
        </div>`;
      }).join("");
      return `<div class="item">
        <div class="rail"><span class="dot" style="background:${groupTint}"></span></div>
        <div class="times"><span class="start">${esc(group.startTime || "--:--")}</span></div>
        <div class="parallel-cards parallel-${Math.min(group.items.length, 3)}">${cards}</div>
      </div>`;
    }).join("");
    return `<section class="day" style="${di ? "" : ""}">
      <div class="day-head">
        <div class="day-num"><span>Jour</span><b>${d.dayNumber}</b></div>
        <div class="day-date">${esc(longDate(d.date))}</div>
      </div>
      <div class="timeline">${items || `<p class="empty">Aucune activité programmée pour cette journée.</p>`}</div>
    </section>`;
  }).join("");

  const legend = Object.entries(catColors).map(([c, t]) => `<span class="lg"><i style="background:${t}"></i>${esc(c)}</span>`).join("");
  const organizerAddress = [
    company.headquartersAddress,
    company.headquartersPostal,
    company.headquartersCity,
  ].filter(Boolean).join(", ");

  w.document.write(`<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8"/>
  <title>Programme — ${esc(event.name)}</title>
  <meta name="viewport" content="width=device-width, initial-scale=1"/>
  <link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=Inter:wght@400;500;600&display=swap" rel="stylesheet">
  <style>
    :root{--c:${color}}
    *{box-sizing:border-box;margin:0;padding:0}
    body{font-family:'Inter',-apple-system,sans-serif;color:#0f172a;background:#f1f5f9;-webkit-print-color-adjust:exact;print-color-adjust:exact}
    .page{max-width:840px;margin:0 auto;background:#fff}
    .hero{position:relative;min-height:260px;display:flex;flex-direction:column;justify-content:flex-end;padding:40px;color:#fff;overflow:hidden}
    .hero-bg{position:absolute;inset:0;${event.banner ? `background:url('${event.banner}') center/cover` : `background:linear-gradient(135deg,var(--c),#0f172a)`}}
    .hero-ov{position:absolute;inset:0;background:linear-gradient(180deg,rgba(15,23,42,.15) 0%,rgba(15,23,42,.82) 100%)}
    .hero-inner{position:relative}
    .kicker{font-family:'Sora';font-weight:600;font-size:12px;letter-spacing:.28em;text-transform:uppercase;opacity:.85;margin-bottom:10px}
    .hero h1{font-family:'Sora';font-weight:800;font-size:40px;line-height:1.05;letter-spacing:-.02em;text-shadow:0 2px 20px rgba(0,0,0,.35)}
    .hero .sub{margin-top:12px;font-size:15px;opacity:.92;max-width:60ch}
    .stats{position:relative;display:flex;flex-wrap:wrap;gap:10px;margin-top:20px}
    .stat{background:rgba(255,255,255,.14);backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.25);border-radius:12px;padding:9px 14px;display:flex;align-items:center;gap:8px;font-size:13px;font-weight:500}
    .stat b{font-family:'Sora';font-weight:700}
    .stat svg{width:15px;height:15px;fill:#fff;opacity:.9}
    .legend{display:flex;flex-wrap:wrap;gap:16px;padding:18px 40px;border-bottom:1px solid #e2e8f0;font-size:12px;color:#475569}
    .lg{display:inline-flex;align-items:center;gap:7px;font-weight:500}
    .lg i{width:11px;height:11px;border-radius:50%;display:inline-block}
    .body{padding:8px 40px 48px}
    .day{margin-top:34px}
    .day-head{display:flex;align-items:center;gap:16px;margin-bottom:18px}
    .day-num{display:flex;flex-direction:column;align-items:center;justify-content:center;width:60px;height:60px;border-radius:16px;background:var(--c);color:#fff;line-height:1;flex-shrink:0}
    .day-num span{font-size:10px;letter-spacing:.14em;text-transform:uppercase;opacity:.85;margin-bottom:3px}
    .day-num b{font-family:'Sora';font-weight:800;font-size:24px}
    .day-date{font-family:'Sora';font-weight:700;font-size:17px;text-transform:capitalize;color:#1e293b}
    .timeline{position:relative;padding-left:4px}
    .item{position:relative;display:grid;grid-template-columns:20px 62px 1fr;gap:14px;padding-bottom:16px}
    .rail{position:relative;display:flex;justify-content:center}
    .rail:before{content:"";position:absolute;top:6px;bottom:-16px;width:2px;background:#e2e8f0}
    .item:last-child .rail:before{display:none}
    .dot{width:13px;height:13px;border-radius:50%;margin-top:4px;box-shadow:0 0 0 4px #fff,0 0 0 5px #e2e8f0;z-index:1}
    .times{text-align:right;padding-top:2px}.times .start{display:block;font-family:'Sora';font-weight:700;font-size:14px;color:#0f172a}
    .parallel-cards{display:grid;grid-template-columns:1fr;gap:10px;min-width:0}.parallel-2{grid-template-columns:repeat(2,minmax(0,1fr))}.parallel-3{grid-template-columns:repeat(3,minmax(0,1fr))}
    .card{height:168px;border:1px solid #e8eaf0;border-left:3px solid var(--tint);border-radius:12px;padding:14px 16px;background:#fff;box-shadow:0 1px 2px rgba(15,23,42,.04);min-width:0;overflow:auto}.room{font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--tint);margin-bottom:5px}.ends-at{font-size:11px;font-weight:600;color:#64748b;margin-top:8px}
    .card-head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}
    .card-head h3{font-family:'Sora';font-weight:600;font-size:15px;color:#0f172a}
    .cat{font-size:10.5px;font-weight:600;padding:3px 9px;border-radius:999px;white-space:nowrap;text-transform:uppercase;letter-spacing:.03em}
    .descr{margin-top:6px;font-size:13px;color:#475569;line-height:1.5}
    .metas{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}
    .chip{display:inline-flex;align-items:center;gap:5px;font-size:11.5px;color:#64748b;background:#f1f5f9;border-radius:8px;padding:4px 9px;font-weight:500}
    .chip svg{width:13px;height:13px;fill:#94a3b8}
    .empty{color:#94a3b8;font-size:13px;font-style:italic;padding:8px 0}
    .foot{border-top:1px solid #e2e8f0;padding:22px 40px;display:flex;align-items:center;justify-content:space-between;color:#94a3b8;font-size:12px}
    .foot b{font-family:'Sora';color:var(--c)}
    @media (max-width:620px){.body{padding:8px 20px 40px}.legend{padding:16px 20px}.parallel-2,.parallel-3{grid-template-columns:1fr}.card{height:168px;padding:10px}.card-head{flex-direction:column}.hero{padding:28px 20px}.hero h1{font-size:32px}}
    @media print{body{background:#fff}.page{max-width:100%}.day{break-inside:avoid}.item{break-inside:avoid}}
  </style></head>
  <body><div class="page">
    <header class="hero"><div class="hero-bg"></div><div class="hero-ov"></div>
      <div class="hero-inner">
        <div class="kicker">Programme officiel</div>
        <h1>${esc(event.name)}</h1>
        ${event.description ? `<p class="sub">${esc(event.description)}</p>` : ""}
        <div class="stats">
          <span class="stat"><svg viewBox="0 0 24 24"><path d="M7 2v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H9V2H7zm12 8v10H5V10h14z"/></svg><b>${dateRange}</b></span>
          ${event.city ? `<span class="stat"><svg viewBox="0 0 24 24"><path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>${esc(event.city)}</span>` : ""}
          <span class="stat"><b>${sortedDays.length}</b> jour${sortedDays.length > 1 ? "s" : ""}</span>
          <span class="stat"><b>${totalActs}</b> activité${totalActs > 1 ? "s" : ""}</span>
        </div>
      </div>
    </header>
    ${legend ? `<div class="legend">${legend}</div>` : ""}
    <main class="body">${daysHtml || `<p class="empty" style="padding:40px 0;text-align:center">Aucun jour programmé.</p>`}</main>
    <footer class="foot"><span>Programme généré par <b>JustPlanIt</b></span><span>${esc(company.companyName || "")}${organizerAddress ? ` · ${esc(organizerAddress)}` : ""}</span></footer>
  </div>
  <script>window.onload=function(){setTimeout(function(){window.focus();window.print();},400)}</script>
  </body></html>`);
  w.document.close();
}
